import { Component } from 'opus-angular-seed-core';

const SEARCH_DEBOUNCE = 300;

@Component({
    bindings: {
        model: '=',
        placeholder: '@',
        onChange: '&'
    },
    template: `
        <div class="search02 mt10">
            <input type="text"
                   placeholder="{{ vm.placeholder }}"
                   ng-model="vm.model"
                   ng-change="vm.onModelChanged()">
        </div>
    `
})
export default class {
    constructor ($timeout) {
        this.$timeout = $timeout;
    }

    onModelChanged () {
        this.$timeout.cancel(this.searchPromise);
        this.searchPromise = this.$timeout(() => this.onChange(), SEARCH_DEBOUNCE);
    }

    $onDestroy () {
        this.$timeout.cancel(this.searchPromise);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/list/search/index.js